import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { PrebidModulesContext } from 'features/globalSetup/contexts/PrebidModulesContext'
import { ModuleEnabledSection } from '../GeneralCommonFormContainer/sections/ModuleEnabledSection'
import {
  editPaapiSchema,
  EditPaapiSchema,
  editPaapiSchemaDefaults,
} from '../schemas/editPaapiSchema'
import { ParametersSection } from './ParametersSection'
import { useGetWorkspaceBidders } from './useGetWorkspaceBidders'
import { useUpdatePaapiPrebidModule } from './useUpdatePaapiPrebidModule'

export const GeneralPaapiForm = (): React.JSX.Element => {
  const { formId, loading, setTouched, setValid, workspacePrebidModule } =
    useContext(PrebidModulesContext)

  if (!workspacePrebidModule) {
    throw Error('WorkspacePrebidModule should be accessible')
  }

  const { errors: apiErrors, update } = useUpdatePaapiPrebidModule()

  const { loading: loadingWorkspaceBidders, workspaceBidders } = useGetWorkspaceBidders()
  if (loadingWorkspaceBidders) {
    return <Loading />
  }

  return (
    <Form<EditPaapiSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={editPaapiSchema}
      schemaDefaults={editPaapiSchemaDefaults(workspacePrebidModule, workspaceBidders)}
    >
      {() => (
        <>
          <ModuleEnabledSection />
          <ParametersSection />
        </>
      )}
    </Form>
  )
}
